import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import styles from './WarrantyHeroSection.module.scss';

const HeroSection = ({ heroSectionData }) => {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    const getImageUrlFromField = (field) => {
      if (!field?.value?.src) return '';
      return field.value.src;
    };

    // 根据设备类型获取对应的图片
    if (isMobile) {
      return (
        getImageUrlFromField(imageField.fields.mobileImage) ||
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    if (isTablet) {
      return (
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    return getImageUrlFromField(imageField.fields.desktopImage) || '';
  };

  // 处理Sitecore格式的图片数据
  const imageField = heroSectionData?.image;
  const imageUrl = getImageUrl(imageField);

  // 处理Sitecore格式的富文本数据
  const textContent = heroSectionData?.text || '';

  return (
    <div className={styles.container} data-aos="fade-up">
      <div className={styles.wrapper}>
        <img src={imageUrl} alt="Hero background" className={styles.backgroundImage} />
        <div className={styles.contentContainer}>
          <div dangerouslySetInnerHTML={{ __html: textContent }} />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
